/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppMessage} from '../api'

 export const useQueryGetAppMessage = createReactQueryHook('getAppMessage', getAppMessage)
